/**
 * Production-safe logger utility
 * Only logs debug/info messages in development mode
 */

const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'dev';

export const logger = {
  debug: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    // Always log warnings (even in production)
    console.warn(...args);
  },
  error: (...args) => {
    // Always log errors (even in production)
    console.error(...args);
  },
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
};
